var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { html } from "lit-html";
import { useEffectWithoutCleanup, useState, useValidationContext } from "GlobalShared/haunted/CustomHooks";
import { BoolAnswer as WebBoolAnswer } from "WebServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { BoolAnswer as AdminBoolAnswer } from "AdminServices/APIs/self/models/V1/CompanyInfo/Questionnaire/Answers";
import { BoolValidator } from "./AnswerValidators";
import { mapBooleanToState, mapStateToBoolean } from "GlobalShared/helpers/booleanHelper";
export const observedAttributes = ["q11e", "questionId"];
export const useShadowDOM = false;
export const name = "ww-answer-bool";
const DEFAULTS = {
  validation: {
    required: false
  }
};
export class BoolChangeEvent extends CustomEvent {
  constructor(detail) {
    super("change", { detail, bubbles: true });
  }
}
export const Component = (host) => {
  const props = {
    q11e: host.q11e,
    questionId: host.questionId,
    validation: host.validation !== void 0 ? __spreadValues(__spreadValues({}, DEFAULTS.validation), host.validation) : DEFAULTS.validation
  };
  const getBoolAnswer = () => {
    var _a;
    if ((_a = props.q11e) == null ? void 0 : _a.isAdmin) {
      new AdminBoolAnswer({ Value: currentVal, QuestionId: props.questionId });
    }
    return new WebBoolAnswer({ Value: currentVal, QuestionId: props.questionId });
  };
  const onChange = (e) => {
    const newValue = mapStateToBoolean(e.detail.state);
    setDispatchIfValid(true);
    setCurrentVal(newValue);
  };
  const [currentVal, setCurrentVal] = useState(void 0);
  const [question, setQuestion] = useState(void 0);
  const validationContext = useValidationContext(new BoolValidator(props.validation));
  const [dispatchIfValid, setDispatchIfValid] = useState(false);
  useEffectWithoutCleanup(() => {
    if (validationContext.validationResult.isValid() && dispatchIfValid) {
      setDispatchIfValid(false);
      host.dispatchEvent(
        new BoolChangeEvent({
          answer: getBoolAnswer()
        })
      );
    }
  }, [validationContext.validationResult]);
  useEffectWithoutCleanup(() => {
    validationContext.validate(getBoolAnswer());
  }, [currentVal]);
  useEffectWithoutCleanup(() => {
    if (props.q11e) {
      setQuestion(props.q11e.getQuestion(props.questionId));
      const answer = props.q11e.getAnswer(props.questionId);
      if (answer instanceof WebBoolAnswer || answer instanceof AdminBoolAnswer) {
        setCurrentVal(answer.Value);
      }
    }
  }, [props.q11e, props.questionId]);
  return html`
		${props.q11e !== void 0 && question !== void 0 ? html`<dc-toggle
					.label=${question.Label + (props.validation.required ? "*" : "")}
					.tooltip=${question.Tooltip !== void 0 ? question.Tooltip : ""}
					.state=${mapBooleanToState(currentVal)}
					.readonly=${props.q11e.isReadonly(props.questionId)}
					@change=${onChange}
			  ></dc-toggle>` : ""}
	`;
};
